import { buildAssignedTrainingRequest } from './buildAssignedTrainingRequest'
import { buildExamModeRequest } from './buildExamModeRequest'
import { buildMistakeReviewRequest } from './buildMistakeReviewRequest'
import { buildStandardTrainingRequest } from './buildStandardTrainingRequest'

export function buildTestFetchRequest({
  isExamMode,
  isMistakeReviewMode,
  isAssignedTestMode,
  resolvedMistakeQuestionCount,
  currentAssignedTest,
  questionCount,
  selectedTopics
}) {
  const mode = isExamMode ? 'EXAM' : 'TRAINING_MODE'
  const isMistakeMode = mode === 'TRAINING_MODE' && isMistakeReviewMode
  const isAssignedMode = mode === 'TRAINING_MODE' && isAssignedTestMode

  const requiredCount = isMistakeMode
    ? resolvedMistakeQuestionCount
    : isAssignedMode
      ? Number(currentAssignedTest?.questionCount || 0)
      : mode === 'TRAINING_MODE'
        ? questionCount
        : 40

  if (isMistakeMode) {
    return {
      mode,
      isMistakeMode,
      isAssignedMode,
      requiredCount,
      params: buildMistakeReviewRequest({
        questionCount: requiredCount
      })
    }
  }

  if (isAssignedMode) {
    return {
      mode,
      isMistakeMode,
      isAssignedMode,
      requiredCount,
      params: buildAssignedTrainingRequest({
        assignmentId: currentAssignedTest?.id,
        questionCount: requiredCount
      })
    }
  }

  if (mode === 'EXAM') {
    return {
      mode,
      isMistakeMode,
      isAssignedMode,
      requiredCount,
      params: buildExamModeRequest()
    }
  }

  return {
    mode,
    isMistakeMode,
    isAssignedMode,
    requiredCount,
    params: buildStandardTrainingRequest({
      questionCount: requiredCount,
      selectedTopics
    })
  }
}
